export const ITEMS_PER_PAGE = 15
export const MAX_RESULT_ITEM = 1000
export const MAX_FILE_SIZE = 2000000000

export const CLIENT_ERROR = {
    LOGIN_ERROR: 1,
    USER_NOT_FOUND: 2,
    LOGIN_PROVIDER_NOT_FOUND: 3,
    INVALID_PROVIDER_DATA: 4,

    INVALID_EMAIL_PASSWORD: 20,
    ACCOUNT_LOCKED: 21,
    ACCOUNT_PANDING: 22,

    REDIRECT: 99,
}

export const SERVER_DATA_TYPE = {
    TEXT: "text",
    CONTENT: "content",
    INT: "int",
    DECIMAL: "decimal",
    DOUBLE: "double",
    BOOLEAN: "bool",
    DATE: "date",
    LIST: ['text', 'content', 'int', 'decimal', 'double', 'bool', 'date']
}

export const SERVER_FUNC = {
    CURRENT_DATE: 'current_date',
    CURRENT_DATE_TIME: 'current_date_time',
    CURRENT_DAY: 'current_day',
    CURRENT_MONTH: 'current_month',
    CURRENT_YEAR: 'current_year',
    CURRENT_LOCAL_YEAR: 'current_local_year',
    CURRENT_BUGGET_YEAR: 'current_bugget_year',
    CURRENT_QUATER: 'current_quater',
    CURRENT_BUGGET_QUATER: 'current_bugget_quater',
    CURRENT_ROW_ID: 'current_row_id',
    CURRENT_USER_ID: 'current_user_id',
    CURRENT_USERNAME: 'current_username',
    GUID: 'guid',
    LIST: ['current_date', 'current_date_time', 'current_day', 'current_month', 'current_year', 'current_local_year', 'current_bugget_year', 'current_quater', 'current_bugget_quater', 'current_row_id', 'current_user_id', 'current_username', 'guid']
}

export const COMPARE = {
    EQUAL: "=",
    NOT_EQUAL: "<>",
    MORE__THAN: ">",
    MORE_EQUAL: ">=",
    LESS_THAN: "<",
    LESS_EQUAL: "<=",
    CONTAINS: "contain",
    LIKE: "like",
    START: "start",
    END: "end",
    IS_NULL: "isNull",
    IS_NOT_NULL: "isNotNull",
    IS_LATE: "isLate",
    IS_NOT_LATE: "isNotLate",
    LIST: [
        "=",
        "<>",
        ">",
        ">=",
        "<",
        "<=",
        "contain",
        "like",
        "start",
        "end",
        "isNull",
        "isNotNull",
        "isLate",
        "isNotLate"
    ]
}

export const OP = {
    AND: 'and',
    OR: 'or',
    LIST: ['and', 'or']
}

export const TOKEN_HEADER_NAME = "Authorization"
export const TOKEN_HEADER_HEADER_TYPE = "Bearer"
export const TOKEN_HEADER_QUERY_NAME = "access_token"

export const FIELD_SOURCE = {
    PAGE_MODEL: "page_model",
    MODEL: "model",
    VARIABLE: "variable",
    ROW_ID: "row_id",
    ROUTE_PARAM: "route_param",
    VALUE: "value",
    FUNCTION: "function",
    LIST_SERVER: ['value', 'variable', 'function'],
    LIST_SERVER_OUTPUT: ['variable'],
    LIST_CLIENT: ['value', 'page_model', 'model', 'variable', 'row_id', 'route_param'],
    LIST_CLIENT_WITH_FUNCTION: ['value', 'page_model', 'model', 'variable', 'row_id', 'route_param', 'function'],
    LIST_CLIENT_OUTPUT: ['page_model', 'model', 'variable']
}

export const EXP = {
    COMPARE: "compare",
    OPERATION: "operation",
    VALUE: "value",
    CALCULATE: "calculate",
    LIST: ['compare', 'operation', 'value', 'calculate']
}

export const CAL = {
    ADD: "+",
    SUBTRACT: "-",
    MULTIPLY: "*",
    DIVIDE: "/",
    LIST: ['+', '-', '*', '/']
}

export const DATA_OUTPUT = {
    NONE: 'none',
    PAGE_MODEL: 'page_model',
    MODEL: "model",
    VARIABLE: "variable",
    LIST_SERVER: ['none', 'variable'],
    LIST_CLIENT: ['none', 'page_model', 'model', 'variable']
}

export const CLIENT_FUNC = {
    value_null: "value_null",
    current_date: "current_date",
    current_day: "current_day",
    current_month: "current_month",
    current_quater: "current_quater",
    current_year: "current_year",
    current_thai_year: "current_thai_year",
    current_budget_month: "current_budget_month",
    current_budget_quater: "current_budget_quater",
    current_budget_year: "current_budget_year",
    current_thai_budget_year: "current_thai_budget_year",
    LIST: ["value_null", "current_date", "current_day", "current_month", "current_quater", "current_year", "current_thai_year", "current_budget_month", "current_budget_quater", "current_budget_year", "current_thai_budget_year"]
}

export const FORMAT = {
    NONE: 'none',
    DATE: 'date',
    DATE_TIME: 'date_time',
    DECIMAL: 'decimal',
    INT: 'int',
    BYTE: 'byte',
    LIST: ['none', 'date', 'date_time', 'decimal', 'int', 'byte', 'html']
}